<template>
<div id="header-section">
    <ul class="header-list">
        <li  class="float-left header-style" v-on:click="onToggleClick" ref="sidbarToggle">
            <span id="hamburger" class="e-icons menu default"></span>
        </li>
        <li class="float-left header-style">
            <span><b>Navigation</b></span>
        </li>
        <li class="float-right header-style nav-pane" style="margin-right:20px">
            <ejs-tooltip content='Shopping Cart'>
              <router-link v-if="isAuthenticated"
              to="/financials/shopping-cart" style="font-size: 18px;">
                <font-awesome-icon :icon="['fas', 'shopping-cart']" />
              </router-link>
              <span class="cart-number-span" v-if="isAuthenticated && shoppingCartItems>0">
              {{ shoppingCartItems }} </span>
            </ejs-tooltip>
        </li>
        <li v-if="isAllowLogin" class="float-right header-style nav-pane">
            <router-link to="/login" data-test-navbar="s-in">
                <span class="top-nav-label sm">Sign in</span>
                <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
            </router-link>
        </li>
        <li v-if="isAllowRegister" class="float-right header-style nav-pane">
            <ejs-tooltip content='Create Account' >
              <router-link to="/register" style="font-size: 18px">
                <font-awesome-icon :icon="['fas', 'user-plus']"/>
              </router-link>
            </ejs-tooltip>
        </li>
        <li class="float-right header-style nav-pane">
            <router-link v-if="isAuthenticated" to="/logout" data-test-navbar="s-out">
                <span class="top-nav-label sm">Sign out</span>
                <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
            </router-link>
        </li>
        <li class="float-right header-style nav-pane">
            <router-link v-if="isAuthenticated" :to="`/scc-user-profile/${authUserId}`">
                <span class="top-nav-label sm">Welcome, {{ authUserName }}</span>
                <font-awesome-icon :icon="['fas', 'user-edit']" />
            </router-link>
        </li>
    </ul>
</div>
</template>

<script>

export default {
  components: {
  },
  props: {
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    authUserName: {
      type: String,
      default: '',
    },
    authUserId: {
      type: String,
      default: '',
    },
  },
  mounted() {
  },
  data() {
    return {
    };
  },
  computed: {
    shoppingCart() {
      return this.$store.getters.getShoppingCartByUserId;
    },
    isAllowLogin() {
      return !this.isAuthenticated;
    },
    isAllowRegister() {
      return !this.isAuthenticated;
    },
    shoppingCartItems: {
      get() {
        return this.shoppingCart ? this.shoppingCart.shoppingCartItems.length : 0;
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    shoppingCart() {
      this.shoppingCartItems = this.shoppingCart ? this.shoppingCart.shoppingCartItems.length : 0;
    },
  },
  methods: {
    onToggleClick() {
      this.$emit('toggle-click');
    },
  },
};
</script>

<style>
#header-section {
  border-bottom: 1px solid #d2d6de;
  height: 55px;
  background: #0F4B90;
  color: rgb(228, 226, 226);
}

#header-section .header-style {
  line-height: 40px;
  height: 40px;
  padding: 8px;
  list-style: none;
  text-align: center;
  font-size: 18px;
}

#header-section .header-style a {
  text-decoration: none;
  color: rgb(209, 206, 206)
}

#header-section .header-style a.router-link-exact-active {
  color: #fff;
}

#header-section .float-left {
  float: left;
  padding-right: 0px;
}

#header-section .float-right {
  float: right;
  padding-right: 8px;
}

#header-section .header-list {
  padding: 0px;
  margin: 0px;
}

#hamburger.menu {
  font-size: 25px;
  cursor: pointer;
  float: left;
  line-height: 38px;
  left: 25px;
  color: white;
}

#hamburger.menu:before {
  content: '\e99a';
}

.top-nav-label {
  display: none;
  margin-right: 8px;
}

@media only screen and (min-width:320px) {
  /* smartphones, iPhone, portrait 480x320 phones */
  .xxsm {
    display: inline-block;
  }
}

@media (min-width:481px) {
  /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */
  .xsm {
    display: inline-block;
  }
}

@media (min-width:641px) {
  /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
  .sm {
    display: inline-block;
  }
}

@media (min-width:961px) {
  .md {
    display: inline-block;
  }
  /* tablet, landscape iPad, lo-res laptops ands desktops */
}

@media (min-width:1025px) {
  .lg {
    display: inline-block;
  }
  /* big landscape tablets, laptops, and desktops */
}

@media (min-width:1281px) {
  /* hi-res laptops and desktops */
  .xlg {
    display: inline-block;
  }
}
.cart-number-span{
    font-size: 12px !important;
    font-weight: 200 !important;
    color: yellow !important;
    position: fixed !important;
    margin-left: 2px !important;
    margin-top: -2px !important;
   /* border:
    border-radius: 100% !important;
    height: 12px !important;
    width: 12px !important;
    padding-top: 2px !important;
    background: yellow !important;  none;*/
}
</style>
